import { createDMSansFont } from '@my/ui/src/font-dm-sans'

export const headingFont = createDMSansFont(
  {
    size: {
      6: 15,
    },
    transform: {
      6: 'uppercase',
      7: 'none',
    },
    weight: {
      3: '500',
      4: '700',
    },
    face: {
      700: { normal: 'DMSans' },
    },
    letterSpacing: {
      6: -0.6,
    },
  },
  {
    sizeSize: (size) => size,
    sizeLineHeight: (fontSize) => fontSize + 4,
  }
)

export const bodyFont = createDMSansFont(
  {
    face: {
      700: { normal: 'DMSans' },
    },
    letterSpacing: {
      4: 0,
    },
  },
  {
    sizeSize: (size) => Math.round(size * 1.0),
    sizeLineHeight: (size) => size + 5,
  }
)
